import { render, staticRenderFns } from "./ProductSampleForm.vue?vue&type=template&id=219e59a8&"
import script from "./ProductSampleForm.vue?vue&type=script&lang=ts&"
export * from "./ProductSampleForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProductSampleForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports